<template>
  <div>
    <div class="d-flex justify-content-end">
      <add-button
        v-if="activeAddButton"
        :btn-label="'Article'"
        @click.native="$router.push('/article/article/create')"
      />
      <export-button class="ml-2" @onExport="openReportModal" />
    </div>
    <div
      class="
        d-flex
        flex-wrap
        align-items-end
        horoscope-type-filter-container
        justify-content-end
      "
    >
      <div class="mr-1 ml-1 mb-1">
        <label for="horoscope-type-status">
          {{ "Status" }}
        </label>
        <v-select
          id="horoscope-type-status"
          v-model="form.status"
          :searchable="false"
          class="horoscope-type-status-filter bg-dropdown"
          :class="form.status ? 'horoscope-type-status-selected' : null"
          placeholder="Status"
          :options="statusOption"
          @input="(option) => onSelectFilter('status', option)"
        />
      </div>
      <div class="search-container mb-1">
        <search :on-search-input="onSearchArticle" />
      </div>
    </div>
  </div>
</template>

<script>
import { BFormGroup, BFormInput } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import Search from "@/views/components/search/Search.vue";
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue";
import AddButton from "@/views/components/button/AddButton.vue";
import vSelect from "vue-select";
import { reactive, getCurrentInstance } from "@vue/composition-api";
import ExportButton from "@/views/components/button/ExportButton.vue";

export default {
  components: {
    BFormGroup,
    BFormInput,
    Search,
    CalendarPickerIcon,
    AddButton,
    flatPickr,
    vSelect,
    ExportButton,
  },
  props: {
    statusOption: Array,
    onSearchArticle: Function,
    onSelectFilter: Function,
    activeAddButton: Boolean
  },
  setup() {
    const vm = getCurrentInstance().proxy;

    const form = reactive({
      status: null,
    });
    const openReportModal = () => {
      vm.$emit("onOpenExportModal");
    };
    return {
      form,
      openReportModal,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/pages/article/article-filter-header.css";
</style>
